/* bs-alle-maten.js: filteren, sorteren en toevoegen op de pagina "Alle maten".
   Hoort bij sections/bs-alle-maten.liquid. Zonder dit script staat alles er gewoon:
   alle groepen zichtbaar, filterknoppen springen naar de groep, "In winkelwagen" is een formulier.
   Toevoegen loopt via window.BBWinkel (assets/bb-winkelwagen.js). Er wordt hier niet met geld gerekend:
   alle prijzen staan al in de pagina via snippets/bs-prijs, sorteren leest alleen data-attributen. */
(function () {
  'use strict';

  function tekstAantal(n) { return n + (n === 1 ? ' product' : ' producten'); }

  function initWortel(wortel) {
    if (wortel.__bsAm) { return; }
    wortel.__bsAm = true;

    var chips = Array.prototype.slice.call(wortel.querySelectorAll('[data-bs-am-filter]'));
    var groepen = Array.prototype.slice.call(wortel.querySelectorAll('[data-bs-am-groep]'));
    var aantalEl = wortel.querySelector('[data-bs-am-aantal]');
    var sorteerVeld = wortel.querySelector('[data-bs-am-sorteer-veld]');
    var sorteer = wortel.querySelector('[data-bs-am-sorteer]');

    /* ---------- filter ---------- */
    function filter(waarde, hashBijwerken) {
      var bestaat = waarde === 'alle' || groepen.some(function (g) { return g.getAttribute('data-bs-am-groep') === waarde; });
      if (!bestaat) { waarde = 'alle'; }
      var zichtbaar = 0;
      groepen.forEach(function (g) {
        var aan = waarde === 'alle' || g.getAttribute('data-bs-am-groep') === waarde;
        g.hidden = !aan;
        if (aan) { zichtbaar += g.querySelectorAll('[data-bs-am-kaart]').length; }
      });
      chips.forEach(function (c) {
        var aan = c.getAttribute('data-bs-am-filter') === waarde;
        c.setAttribute('aria-pressed', aan ? 'true' : 'false');
        c.removeAttribute('aria-current');
      });
      if (aantalEl) { aantalEl.textContent = tekstAantal(zichtbaar); }
      if (hashBijwerken && window.history && window.history.replaceState) {
        var hash = waarde === 'alle' ? '' : '#diameter-' + waarde;
        try { window.history.replaceState(null, '', window.location.pathname + window.location.search + hash); } catch (e) { /* geen probleem */ }
      }
    }

    chips.forEach(function (c) {
      c.setAttribute('role', 'button');
      c.addEventListener('click', function (e) {
        e.preventDefault();
        filter(c.getAttribute('data-bs-am-filter'), true);
      });
      c.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); c.click(); }
      });
    });

    var begin = 'alle';
    var m = /^#diameter-(\d+)$/.exec(window.location.hash || '');
    if (m) { begin = m[1]; }
    filter(begin, false);

    /* ---------- sorteren (binnen elke groep; de tipkaart blijft achteraan) ---------- */
    if (sorteer && sorteerVeld) {
      sorteerVeld.hidden = false;
      sorteer.addEventListener('change', function () {
        var sleutel = sorteer.value === 'prijs' ? 'prijs' : (sorteer.value === 'permeter' ? 'permeter' : 'volgorde');
        groepen.forEach(function (g) {
          var raster = g.querySelector('[data-bs-am-raster]');
          if (!raster) { return; }
          var kaarten = Array.prototype.slice.call(raster.querySelectorAll('[data-bs-am-kaart]'));
          kaarten.sort(function (a, b) {
            var d = Number(a.getAttribute('data-' + sleutel)) - Number(b.getAttribute('data-' + sleutel));
            if (d !== 0) { return d; }
            return Number(a.getAttribute('data-volgorde')) - Number(b.getAttribute('data-volgorde'));
          });
          var tip = raster.querySelector('[data-bs-am-tip]');
          kaarten.forEach(function (k) { raster.insertBefore(k, tip || null); });
        });
      });
    }

    /* ---------- in winkelwagen ---------- */
    wortel.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-bs-am-toevoegen]') : null;
      if (!form) { return; }
      var winkel = window.BBWinkel;
      if (!winkel || typeof winkel.pakketToevoegen !== 'function' || !window.fetch) { return; } // gewoon formulier
      e.preventDefault();

      var knop = form.querySelector('button[type="submit"]');
      var knopTekst = form.querySelector('[data-bs-am-knoptekst]');
      var melding = form.querySelector('[data-bs-am-melding]');
      if (!knop || knop.getAttribute('data-status') === 'bezig') { return; }

      var idVeld = form.querySelector('input[name="id"]');
      var id = idVeld ? Number(idVeld.value) : 0;
      if (!id) { form.submit(); return; }
      var naam = form.getAttribute('data-naam') || 'Het artikel';

      clearTimeout(form.__bsAmTimer);
      knop.setAttribute('data-status', 'bezig');
      knop.setAttribute('aria-disabled', 'true');
      if (knopTekst) { knopTekst.textContent = 'Bezig met toevoegen'; }
      if (melding) { melding.textContent = ''; melding.removeAttribute('data-soort'); }

      winkel.pakketToevoegen({ regels: [{ product: { id: id }, aantal: 1 }] }, 'cart-icon-bubble')
        .then(function (uit) {
          winkel.meldWijziging(uit.antwoord);
          knop.setAttribute('data-status', 'klaar');
          if (knopTekst) { knopTekst.textContent = 'Toegevoegd'; }
          if (melding) {
            melding.textContent = naam + ' ligt in je winkelwagen. ';
            var link = document.createElement('a');
            link.href = (winkel.wortel ? winkel.wortel() : '/') + 'cart';
            link.textContent = 'Bekijk winkelwagen';
            melding.appendChild(link);
          }
        })
        .catch(function (fout) {
          knop.removeAttribute('data-status');
          if (knopTekst) { knopTekst.textContent = 'In winkelwagen'; }
          if (melding) {
            melding.setAttribute('data-soort', 'fout');
            melding.textContent = (fout && fout.allesOfNiets && fout.uitlegVanShopify)
              ? 'Toevoegen lukte niet: ' + fout.uitlegVanShopify
              : 'Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.';
          }
        })
        .then(function () {
          knop.removeAttribute('aria-disabled');
          if (knop.getAttribute('data-status') === 'klaar') {
            form.__bsAmTimer = setTimeout(function () {
              knop.removeAttribute('data-status');
              if (knopTekst) { knopTekst.textContent = 'In winkelwagen'; }
            }, 2500);
          }
        });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bs-am]'), initWortel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* thema-editor: sectie opnieuw geladen */
  document.addEventListener('shopify:section:load', start);
})();
